import { render, staticRenderFns } from "./RssBlogItem.vue?vue&type=template&id=ce8638ae&scoped=true&"
import script from "./RssBlogItem.vue?vue&type=script&lang=js&"
export * from "./RssBlogItem.vue?vue&type=script&lang=js&"
import style0 from "./RssBlogItem.vue?vue&type=style&index=0&id=ce8638ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8638ae",
  null
  
)

export default component.exports